<template>
  <ul class="flex flex-col space-y-2">
    <li v-for="option in processedOptions">
      <p><span class="font-semibold uppercase">{{option.label}}:</span> {{option.value}}</p>
    </li>
<!--    <li>-->
<!--      <p><span class="font-semibold">BATT CAVITY INSULATION:</span> Yes</p>-->
<!--    </li>-->
<!--    <li>-->
<!--      <p><span class="font-semibold">SHEETHING:</span> Other</p>-->
<!--    </li>-->
<!--    <li>-->
<!--      <p><span class="font-semibold">INSIDE WRB:</span> Sheet</p>-->
<!--    </li>-->
<!--    <li>-->
<!--      <p><span class="font-semibold">INSULATION:</span> EnergyShield Pro</p>-->
<!--    </li>-->
<!--    <li>-->
<!--      <p><span class="font-semibold">CLADDING:</span> Metal Panel (MCM/ACM)</p>-->
<!--    </li>-->
  </ul>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  computed: {
    processedOptions: function() {
      return Object.keys(this.options).map(key => {
        let value = this.options[key].value
        let label = this.options[key].label
        if (value === null) {
          return null;
        }
        if (value === true) {
          value = 'YES'
        }
        if (value === false) {
          value = 'NO'
        }
        if (typeof value === 'string') {
          value = transformValues(value);
        }
        return {
          label: label,
          value: value
        }
      }).filter(val => val !== null);
    }
  },
  props: {
    options: {
      type: Object,
      required: true
    }
  }
}
const productMappings = {
    'steel-frame': 'Steel Frame',
    'masonry': 'Masonry',
    'wood-frame': 'Wood Frame',
    'mcm-acm': 'Metal Panel (MCM/ACM)',
    'cement-board': 'Cement Board',
    'stucco': 'Stucco',
    'wood': 'Siding',
    'liquid': 'Liquid',
    'sheet': 'Sheet',
    'none': 'None',
    'brick': 'Brick',
    'stone': 'Stone',
    'terracota': 'Terracota',
    'iso-as-wrb': 'ISO as WRB with appropriate detailing',
    'osb': 'OSB',
    'gypsum': 'Gypsum',
    'plywood': 'Plywood',
    'other': 'Other',
    'energyshield': 'EnergyShield',
    'energyshield-pro': 'EnergyShield Pro',
    'energy-cgf-pro': 'EnergyShield CGF Pro',
    'energyshield-ply-pro': 'EnergyShield Ply Pro',
    'energyshield-ply-pro-wrb': 'EnergyShield Ply Pro with WRB',
    'energyshield-cgf': 'EngergyShield CGF',
    'energyshield-xr': 'EngergyShield XR'
};
function transformValues(str) {
    // Return the mapped value if it exists, otherwise return the original string
    return productMappings[str] || str;
}
</script>
